/* eslint-disable complexity */
import { Option } from '@com-delta-omnichannel/mach';

import {
  BookWidgetAem,
  BookWidgetTripTypesField,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { TRIP_TYPE_IMAGES } from '../../constants/common.constants';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { DefaultLookupFieldsValue } from '../../models/core-apis/default-lookup.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import {} from '../../models/states/book-widget-state.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

export const prepareTripTypesField = (
  bookWidgetAem: BookWidgetAem | null,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  defaultLookupFieldsValue: DefaultLookupFieldsValue | null,
  queryParams: QueryParams | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  hasDeepLinkingParams: boolean
): BookWidgetTripTypesField => {
  let tripTypeOptions: TripTypeOptions[] = [];

  if (defaultLookupFieldsValue?.tripTypeOptions?.length) {
    tripTypeOptions = defaultLookupFieldsValue.tripTypeOptions;
  } else if (catalogApiFieldsValue?.tripTypeOptions?.length) {
    tripTypeOptions = catalogApiFieldsValue.tripTypeOptions;
  } else if (bookWidgetAem?.defaultValues?.tripTypeOptions) {
    tripTypeOptions = bookWidgetAem.defaultValues.tripTypeOptions;
  }

  const dropdownOptions: Option[] = [];
  const {
    tripTypesField: { roundTrip = '', onwWay = '', multiCity = '' } = {}
  } = bookWidgetAem || {};

  tripTypeOptions.forEach((tripTypeOption) => {
    let label = roundTrip;
    let iconUrl = TRIP_TYPE_IMAGES.RT;
    if (tripTypeOption === TripTypeOptions.MULTI_CITY) {
      label = multiCity;
      iconUrl = TRIP_TYPE_IMAGES.MC;
    } else if (tripTypeOption === TripTypeOptions.ONE_WAY) {
      label = onwWay;
      iconUrl = TRIP_TYPE_IMAGES.OW;
    }

    dropdownOptions.push({
      label,
      value: tripTypeOption,
      icon: { src: iconUrl, alt: '', show: true },
      activeIcon: { src: iconUrl, alt: '', show: true }
    });
  });

  let selectedTripType: TripTypeOptions | null = null;

  if (
    !bookWidgetFieldsMasterConfig?.tripTypesField?.disable &&
    queryParams?.tripType
  ) {
    selectedTripType = queryParams?.tripType;
  } else if (!hasDeepLinkingParams) {
    if (
      bookWidgetFieldsMasterConfig?.tripTypesField?.disable &&
      defaultLookupFieldsValue?.selectTripType
    ) {
      selectedTripType = defaultLookupFieldsValue.selectTripType;
    } else if (
      !bookWidgetFieldsMasterConfig?.tripTypesField?.disable &&
      retrieveSearchData?.selectTripType
    ) {
      selectedTripType = retrieveSearchData.selectTripType;
    } else if (defaultLookupFieldsValue?.selectTripType) {
      selectedTripType = defaultLookupFieldsValue.selectTripType;
    } else if (catalogApiFieldsValue?.selectTripType) {
      selectedTripType = catalogApiFieldsValue.selectTripType;
    } else if (bookWidgetAem?.defaultValues?.selectTripType) {
      selectedTripType = bookWidgetAem.defaultValues.selectTripType;
    }
  }

  let indexOfSelectedTripType = -1;
  if (selectedTripType) {
    indexOfSelectedTripType = dropdownOptions.findIndex(
      ({ value }) => value === selectedTripType
    );
  }

  if (indexOfSelectedTripType === -1) {
    selectedTripType = dropdownOptions[0].value as TripTypeOptions;
    dropdownOptions[0].selected = true;
  } else {
    dropdownOptions[indexOfSelectedTripType].selected = true;
  }

  return {
    dropdownOptions,
    selectedTripType: selectedTripType as TripTypeOptions,
    disable: bookWidgetFieldsMasterConfig.tripTypesField?.disable || false
  };
};
